var map = {
	"./chat-icon-bottom-nav-mobile-active.webp": 2707,
	"./chat-icon-bottom-nav-mobile.webp": 2708,
	"./home-icon-bottom-nav-mobile-active.webp": 2709,
	"./home-icon-bottom-nav-mobile-active_b.webp": 2710,
	"./home-icon-bottom-nav-mobile.webp": 2711,
	"./home-icon-bottom-nav-mobile_b.webp": 2712,
	"./me-icon-bottom-nav-mobile-active.webp": 2713,
	"./me-icon-bottom-nav-mobile.webp": 2714,
	"./promo-icon-bottom-nav-mobile-active.webp": 2715,
	"./promo-icon-bottom-nav-mobile.webp": 2716,
	"./sponsor-icon-bottom-nav-mobile-active.webp": 2717,
	"./sponsor-icon-bottom-nav-mobile.webp": 2718,
	"./stream-icon-bottom-nav-mobile-active.webp": 2719,
	"./stream-icon-bottom-nav-mobile.webp": 2720
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2706;